$(function() {

  // slider
  $('.fade').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: false
  });

  // search close
  $('.header-search-close').on('click', function() {
    $('.header-search-form').hide("slow").css('display', 'none');
    $('.header-search-prompt').show();
  });

  let timeout_remove_mega_menu_class_from_body;

  $('.has-mega-menu').on('mouseenter', function() {
    clearTimeout(timeout_remove_mega_menu_class_from_body);
    $('body').addClass('mega-menu-visible');
    $(this).addClass('mega-menu-show', 'show');
  });

  $('.has-mega-menu').on('mouseleave', function() {
    $(this).removeClass('mega-menu-show');
    timeout_remove_mega_menu_class_from_body = setTimeout(function() {
      $('body').removeClass('mega-menu-visible');  
    }, 10);
  });
      
});